module.exports = __webpack_public_path__ + "img/select-doctor.24f51efd.svg";